import React, { Component } from "react";
import { Placeholder } from "semantic-ui-react";
import CampaignDetails from "../../components/campaign/CampaignDetails";
// Setup the localizer by providing the moment (or globalize) Object
// to the correct localizer.

class CampaignView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      eventsList: [],
      campaign: null
    };
  }
  render() {
    const { loading } = this.state;
    return (
      <div>
        {loading ? (
          <Placeholder>
            <Placeholder.Header>
              <Placeholder.Line length="very short" />
              <Placeholder.Line length="long" />
            </Placeholder.Header>
            <Placeholder.Paragraph />
          </Placeholder>
        ) : (
          <CampaignDetails campaignId={this.props.match.params.id} loading={loading} />
        )}
      </div>
    );
  }
}

export default CampaignView;
